/* eslint-disable */
import Phone from '../components/Phone/Phone';
import React from 'react';
import {appendBasePath} from '../utils/nav.utils';
import config from '../config/config';

const settings = {};

export default settings;

export const DOB_FAILURE = 'DOB_FAILURE';
export const ADDRESS_INCOMPLETE = 'ADDRESS_INCOMPLETE';
export const MISSING_USERNAME = 'MISSING_USERNAME';
export const FOREIGN_ADDRESS = 'FOREIGN_ADDRESS';
export const RMD_ELIGIBLE_AGE_CHECK = 'RMD_ELIGIBLE_AGE_CHECK';
export const RMD_ELIGIBLE_ACCOUNT_CHECK = 'RMD_ELIGIBLE_ACCOUNT_CHECK';
export const ALL_FUNDS_AUTO_SELL = 'ALL_FUNDS_AUTO_SELL';
export const CHECK_SERVICE_FEATURE = 'CHECK_SERVICE_FEATURE';
export const ALL_FUNDS_AUTO_EXCHANGE = 'ALL_FUNDS_AUTO_EXCHANGE';
export const ALL_FUNDS_AUTO_SELL_EXCHANGE = 'ALL_FUNDS_AUTO_SELL_EXCHANGE';
export const DISBURSEMENT_TYPE = 'DISBURSEMENT_TYPE';
export const NO_ELIGIBLE_ACCOUNTS = 'NO_ELIGIBLE_ACCOUNTS';
export const NOT_RMD_ELIGIBLE = 'NOT_RMD_ELIGIBLE';
export const ZERO_RMD_BALANCE = 'ZERO_RMD_BALANCE';
export const UP_TO_THREE_HIDDEN_RMD_ELIGIBE_IRA = 'UP_TO_THREE_HIDDEN_RMD_ELIGIBE_IRA';
export const MORE_THAN_THREE_HIDDEN_RMD_ELIGIBE_IRA = 'MORE_THAN_THREE_HIDDEN_RMD_ELIGIBE_IRA';

export const LANDING_STEP = 'landing';
export const DESTINATION_STEP = 'destination';
export const ADDRESS_STEP = 'CHECK_TO_ADDRESS';
export const BANK_STEP = 'ACH_TO_BANK';
export const REINVEST_STEP = 'EXCHANGE';
export const REINVEST_TO_NEW = 'EXCHANGE_TO_NEW';
export const FREQUENCY_STEP = 'frequency';
export const SF_FREQUENCY_STEP = 'sf_frequency';
export const TAX_WITHHOLDING_STEP = 'tax-withholding';
export const TAX_WITHHOLDING_NOTICE_STEP = 'tax-withholding-notice';
export const DISTRIBUTION_METHOD_STEP = 'distribution';
// export const REINVEST_DISTRIBUTION_STEP = 'reinvestDistribution';
export const REVIEW_SUBMIT_STEP = 'review';

export const deliveryEnum = {
  ElectronicTransferToBank: BANK_STEP,
  CheckToAddress: ADDRESS_STEP,
  InKindTransfer: REINVEST_STEP,
};

export const deliveryMethod = {
  ElectronicTransferToBank: 'Direct Deposit',
  CheckToAddress: 'Mail To',
};

export const PROPORTIONATE_DISTRIBUTION_METHOD_STEP =
  'PROPORTIONATE_DISTRIBUTION_METHOD_STEP';
export const CUSTOM_DISTRIBUTION_METHOD_STEP =
  'CUSTOM_DISTRIBUTION_METHOD_STEP';
export const RETIREMENT = 'RETIREMENT';
export const NON_RETIREMENT = 'NON_RETIREMENT';

export const TOLL_FREE_NUMBER = '(888) 421-0563';
export const REPRESENTATIVE_NUMBER = '(800) 225-5132';
export const RMD_NUMBER = '(877) 495-8459';

export const phoneNumbers = {
  Default: '1-800-775-9304',
  'Personal Services': '1-800-775-9304',
  'Enhanced Personal Services': '1-888-625-9539',
};

export const disclosurePhoneNumbers = {
  Core: '1-800-225-5132',
  'Personal Services': '1-800-225-3222',
  'Enhanced Personal Services': '1-800-377-3081',
};

export const RETURN_MAIL_VERIFY_ADDRESS = 34;
export const STOP_TRANSFER = 31;
export const PENALTY_WITHHOLDING = 32;
export const STOP_REDEMPTION = 46;
export const STOP_EXCHANGE = 44;
export const UNAVAILABLE_FOR_REDEMPTION_ONLINE = 20;
export const ACH_REDEMPTION = 49;

export const destinationOptions = [
  { text: 'Reinvest in Non-Retirement', value: REINVEST_STEP },
  { text: 'Reinvest in Non-Retirement', value: REINVEST_TO_NEW },
  { text: 'Direct Deposit to Bank', value: BANK_STEP },
  { text: 'Mail a Check to My Address', value: ADDRESS_STEP },
];

export const bankStatusList = [
  'verifyMicroDeposits',
  'lapsed',
  'requiresRenewal',
  'preparingMicroDeposits',
  'processing',
  'bankNotAssociated',
  'bankNotLinked',
  'corruptBankData',
];

export const BANK_STATUS = {
  VERIFY_MICRO_DEPOSITS: 'verifyMicroDeposits',
  PREPARING_MICRO_DEPOSITS: 'preparingMicroDeposits',
  PROCESSING: 'processing',
  JUST_ADDED: 'justAdded',
  REQUIRES_RENEWAL: 'requiresRenewal',
  DELETED: 'deleted',
  CORRUPT_BANK_DATA: 'corruptBankData',
  LAPSED: 'lapsed',
  NO_ACH_REDEMPTION: 'noACHRedemption',
  NO_WIRE_REDEMPTION: 'noWireRedemption',
  NO_MAIL_REDEMPTION: 'noWireRedemption',
  NOT_ASSOCIATED: 'bankNotAssociated',
  NOT_LINKED: 'bankNotLinked',
};

export const bankStatusLockMicroLink = {
  lapsed: 'Add a new bank',
  requiresRenewal: 'Add a new bank',
  corruptBankData: 'Add a new bank',
  verifyMicroDeposits: 'Verify Micro-deposits',
};

export const FEDERAL_WITHOLDINGS = {
  NO_SELECTION: 'NO_SELECTION',
  ELECT_FEDERAL_WITHHOLDING: 'ELECT_FEDERAL_WITHHOLDING',
  DECLINE_FEDERAL_WITHHOLDING: 'DECLINE_FEDERAL_WITHHOLDING',
};

export const ACCOUNT_TYPES = {
  INDIVIDUAL: 'INDIVIDUAL',
  JOINT_TENANT: 'JOINT_TENANT',
  TRANSFER_ON_DEATH: 'TRANSFER_ON_DEATH',
  ROTH_IRA_DECEASED_BENE: 'ROTH_IRA_DECEASED_BENE',
  TRADITIONAL_IRA_DECEASED_BENE: 'TRADITIONAL_IRA_DECEASED_BENE',
};

export const STATE_TYPE = {
  MANDATORY: 'MANDATORY_STATE',
  SPECIAL_STATES: 'SPECIAL_STATES',
  SPECIAL_STATE_TAX: 'SPECIAL_STATE_TAX',
  DC_SPECIAL_STATE: 'DC_SPECIAL_STATE',
  MULTI_STATE: 'MULTI_STATE',
};

export const DC_STATE_CODE = 'DC';

export const COUNTRY_CODES = ['US', 'GU', 'AS', 'MP', 'PR'];
export const SPECIAL_STATES = ['MI', 'DC', 'CT', 'OK', 'AR'];
export const SPECIAL_STATE_TAX = ['MN'];
export const FEDERAL_STATES = ['VT', 'CA'];
export const SPECIAL_DISTRIBUTION_STATES = ['AR', 'KS', 'NC','VT'];
export const REVIEW_SPECIAL_STATES = ['KS', 'NC'];
export const STATE_CODES = {
  AL: {
    stateName: 'Alabama',
  },
  AK: {
    stateName: 'Alaska',
  },
  AZ: {
    stateName: 'Arizona',
  },
  AR: {
    stateName: 'Arkansas',
  },
  CA: {
    stateName: 'California',
  },
  CO: {
    stateName: 'Colorado',
  },
  CT: {
    stateName: 'Connecticut',
  },
  DE: {
    stateName: 'Delaware',
  },
  DC: {
    stateName: 'Washington, D.C.',
  },
  FL: {
    stateName: 'Florida',
  },
  GA: {
    stateName: 'Georgia',
  },
  HI: {
    stateName: 'Hawaii',
  },
  ID: {
    stateName: 'Idaho',
  },
  IL: {
    stateName: 'Illinois',
  },
  IN: {
    stateName: 'Indiana',
  },
  IA: {
    stateName: 'Iowa',
  },
  KS: {
    stateName: 'Kansas',
  },
  KY: {
    stateName: 'Kentucky',
  },
  LA: {
    stateName: 'Louisiana',
  },
  ME: {
    stateName: 'Maine',
  },
  MD: {
    stateName: 'Maryland',
  },
  MA: {
    stateName: 'Massachusetts',
  },
  MI: {
    stateName: 'Michigan',
  },
  MN: {
    stateName: 'Minnesota',
  },
  MS: {
    stateName: 'Mississippi',
  },
  MO: {
    stateName: 'Missouri',
  },
  MT: {
    stateName: 'Montana',
  },
  NE: {
    stateName: 'Nebraska',
  },
  NV: {
    stateName: 'Nevada',
  },
  NH: {
    stateName: 'New Hampshire',
  },
  NJ: {
    stateName: 'New Jersey',
  },
  NM: {
    stateName: 'New Mexico',
  },
  NY: {
    stateName: 'New York',
  },
  NC: {
    stateName: 'North Carolina',
  },
  ND: {
    stateName: 'North Dakota',
  },
  OH: {
    stateName: 'Ohio',
  },
  OK: {
    stateName: 'Oklahoma',
  },
  OR: {
    stateName: 'Oregon',
  },
  PA: {
    stateName: 'Pennsylvania',
  },
  RI: {
    stateName: 'Rhode Island',
  },
  SC: {
    stateName: 'South Carolina',
  },
  SD: {
    stateName: 'South Dakota',
  },
  TN: {
    stateName: 'Tennessee',
  },
  TX: {
    stateName: 'Texas',
  },
  UT: {
    stateName: 'Utah',
  },
  VT: {
    stateName: 'Vermont',
  },
  VA: {
    stateName: 'Virginia',
  },
  WA: {
    stateName: 'Washington',
  },
  WV: {
    stateName: 'West Virginia',
  },
  WI: {
    stateName: 'Wisconsin',
  },
  WY: {
    stateName: 'Wyoming',
  },
};

export const ModalName = {
  AUTO_RMD_TOOLD_AND_RESTRICTIONS_MODAL: 'Benefits Modal',
  EXIT_MODAL: 'Exit Modal',
  CONFIRM_MODAL: 'Confirm Modal',
  FAILURE_MODAL: 'Failure Modal',
  SUCCESS_MODAL: 'Success Modal',
  DELETE_MODAL: 'Delete Modal',
  WITHHOLDING_DISCLOSURE_MODAL: 'Withholding Disclosure Modal',
  STATES_DISCLOSURE_NOTES_MODAL: 'States Disclosure Modal',
  ESTIMATED_START_DATE_MODAL: 'Estimated Start Date Modal',
  PAPERLESS_TERMS_MODAL: 'Paperless Consent Modal',
};

export const CORE_CUSTOMER = 'CORE';
export const MILLION_CUSTOMER = 'MIL';
export const PREFERED_CUSTOMER = 'PFD';
export const HIGH_NET_WORTH = 'HNW';
export const VIP_CUSTOMER = 'VIP';
export const NEW_1_CUSTOMER = 'NEW1';
export const NEW_2_CUSTOMER = 'NEW2';

export const CUSTOMER_SEGMENT_ENUM = {
  5: NEW_1_CUSTOMER,
  6: NEW_2_CUSTOMER,
  7: CORE_CUSTOMER,
  8: PREFERED_CUSTOMER,
  9: HIGH_NET_WORTH,
  10: MILLION_CUSTOMER,
  11: VIP_CUSTOMER,
};

export const stepNavigation = {
  [LANDING_STEP]: {
    step: appendBasePath('/'),
  },
  [DESTINATION_STEP]: {
    back: appendBasePath('/'),
    step: appendBasePath('/destination'),
  },
  [ADDRESS_STEP]: {
    back: appendBasePath('/destination'),
    step: appendBasePath('/address'),
  },
  [BANK_STEP]: {
    back: appendBasePath('/destination'),
    step: appendBasePath('/bank'),
  },
  [DISTRIBUTION_METHOD_STEP]: {
    back: appendBasePath('/destination'),
    step: appendBasePath('/distribution'),
  },
  [PROPORTIONATE_DISTRIBUTION_METHOD_STEP]: {
    back: appendBasePath('/destination'),
    step: appendBasePath('/proportional'),
  },
  [CUSTOM_DISTRIBUTION_METHOD_STEP]: {
    back: appendBasePath('/destination'),
    step: appendBasePath('/custom'),
  },
  [REINVEST_STEP]: {
    back: appendBasePath('/distribution'),
    step: appendBasePath('/reinvest'),
  },
  [REINVEST_TO_NEW]: {
    back: appendBasePath('/distribution'),
    step: appendBasePath('/reinvest'),
  },
  [FREQUENCY_STEP]: {
    back: appendBasePath('/distribution'),
    step: appendBasePath('/frequency'),
  },
  [TAX_WITHHOLDING_STEP]: {
    back: appendBasePath('/frequency'),
    step: appendBasePath('/tax-withholding'),
  },
  [REVIEW_SUBMIT_STEP]: {
    back: appendBasePath('/tax-withholding'),
    step: appendBasePath('/review'),
  },
};

export const stepNavigationEdit = {
  [LANDING_STEP]: {
    step: appendBasePath('/'),
  },
  [DESTINATION_STEP]: {
    back: appendBasePath('/'),
    step: appendBasePath('/edit/destination'),
  },
  [ADDRESS_STEP]: {
    back: appendBasePath('/edit/destination'),
    step: appendBasePath('/edit/address'),
  },
  [BANK_STEP]: {
    back: appendBasePath('/edit/destination'),
    step: appendBasePath('/edit/bank'),
  },
  [DISTRIBUTION_METHOD_STEP]: {
    back: appendBasePath('/edit/destination'),
    step: appendBasePath('/edit/distribution'),
  },
  [PROPORTIONATE_DISTRIBUTION_METHOD_STEP]: {
    back: appendBasePath('/edit/destination'),
    step: appendBasePath('/edit/proportional'),
  },
  [CUSTOM_DISTRIBUTION_METHOD_STEP]: {
    back: appendBasePath('/edit/destination'),
    step: appendBasePath('/edit/custom'),
  },
  [REINVEST_STEP]: {
    back: appendBasePath('/edit/distribution'),
    step: appendBasePath('/edit/reinvest'),
  },
  [REINVEST_TO_NEW]: {
    back: appendBasePath('/edit/distribution'),
    step: appendBasePath('/edit/reinvest'),
  },
  [FREQUENCY_STEP]: {
    back: appendBasePath('/edit/distribution'),
    step: appendBasePath('/edit/frequency'),
  },
  [TAX_WITHHOLDING_STEP]: {
    back: appendBasePath('/edit/frequency'),
    step: appendBasePath('/edit/tax-withholding'),
  },
  [REVIEW_SUBMIT_STEP]: {
    back: appendBasePath('/edit/tax-withholding'),
    step: appendBasePath('/edit/review'),
  },
};

export const helpColumnContent = {
  [DESTINATION_STEP]: {
    title: 'Tell me more',
    subTopics: [
      {
        title: 'Reinvest',
        description: [
          'Keep your money invested and still complete your RMD by investing it in an ' +
            'existing eligible non-retirement account (Individual, Joint Tenant, or Transfer on Death).',
        ],
      },
      {
        title: 'Mail To Check/Direct Deposit',
        description: [
          'Checks will arrive at your address of record an estimated 7-10 days from your withdrawal date.' +
            ' Direct deposits show up in your bank account an estimated 2-3 days from your withdrawal date.',
        ],
      },
    ],
  },
  [ADDRESS_STEP]: {
    title: 'Change address',
    subTopics: [
      {
        description: [
          'There is a 15-day holding period after you change your address. ' +
            'If you change your address, you will be taken out of the Auto-RMD' +
            ' tool. You will not be able to mail an RMD to your new address until after the holding period.',
        ],
        link: {
          text: 'Change address',
          url: 'https://www.troweprice.com/usis/my-accounts/profile/contact-information',
          description:
            'Your information will not be saved and you will not be able to mail in an RMD to your new address until after the 15 day holding period.',
        },
      },
    ],
  },
  [BANK_STEP]: {
    title: 'Add a bank',
    subTopics: [
      {
        description: [
          'There is a 5-day hold on a newly added bank. If you add a bank, you will be taken out of the Auto-RMD tool. You will not be able to set up a direct deposit RMD to the new bank until after the holding period.',
        ],
        link: {
          text: 'Add a bank',
          url: window.document.referrer.includes('wwwstage') ? 'https://wwwstage.troweprice.com/usis/my-accounts/profile/linked-bank-accounts' : 'https://www.troweprice.com/usis/my-accounts/profile/linked-bank-accounts',
          description:
            'Your information will not be saved and you will not be able to set up a direct deposit RMD to a new bank until after a 5-day holding period.',
        },
      },
    ],
  },

  [DISTRIBUTION_METHOD_STEP]: {
    title: 'Tell me more',
    subTopics: [
      {
        title: 'Proportionally',
        description: [
          'Let’s say 75% of your total IRA balance is in Investment A and the remaining 25% of your balance is in Investment B. That means 75% of your RMD will come from Investment A and 25% of your RMD will come from Investment B. ',
        ],
      },
      {
        key: 'CUSTOMIZE',
        title: 'Customize',
        description: [
          'As an example, you can have 50% of your RMD come from Investment A, 25% from Investment B, and 25% from Investment C.',
        ],
      },
    ],
  },
  [PROPORTIONATE_DISTRIBUTION_METHOD_STEP]: {
    title: 'Your RMD will be withdrawn from:',
    subTopics: [
      {
        description: [
          'There is a 5-day holding period after you add a bank. If you choose to add a bank, you ' +
            'will exit the Auto-RMD set up application. You will not be able to use the updated bank until' +
            ' it has been verified.',
        ],
        link: {
          text: 'Add a bank',
          url: 'https://www.troweprice.com/usis/my-accounts/profile/contact-information',
          description:
            'Your information will not be saved and you will not be able to set up a direct deposit RMD to a new bank until after a 5-day holding period.',
        },
      },
    ],
  },
  [FREQUENCY_STEP]: {
    title: 'Tell me more',
    subTopics: [
      {
        description: [
          'Withdrawals will process after market close on your trade date.' +
            ' If one of your trade dates falls on a weekend or holiday, ' +
            'your RMD will be withdrawn on the next business day.',
          'To ensure sufficient processing time there are limitations to the dates on which you can select to have your RMD deposited. December 25 to 31 are ineligible. The first five days of every month are also ineligible, as well as any day that is five business days from the current month and day when you make the auto-RMD request.',
        ],
      },
    ],
  },
  [SF_FREQUENCY_STEP]: {
    title: 'Tell me more',
    subTopics: [
      {
        description: [
          'Withdrawals will process after market close on your trade date.' +
            ' If one of your trade dates falls on a weekend or holiday, ' +
            'your RMD will be withdrawn on the next business day.',
          'To ensure sufficient processing time there are limitations to the dates on which you can select to have your RMD deposited. December 25 to 31 are ineligible. You cannot select the first five days of the month or five days from the date of RMD submission are not available to select.',
        ],
      },
    ],
  },

  [REINVEST_STEP]: {
    title: 'Tell me more',
    subTopics: [
      {
        description: [
          <span>
            The Auto-RMD tool lets you reinvest in one investment (in existing
            Individual, Joint Tenant, or Transfer on Death accounts). Call{' '}
            <Phone phoneNumber={TOLL_FREE_NUMBER} /> for additional reinvestment
            options.
          </span>,
        ],
      },
    ],
  },
  [TAX_WITHHOLDING_NOTICE_STEP]: {
    title: 'Tell me more',
    altTitle: 'Federal & State Income Tax Withholding Notice',
    subTopics: [
      {
        emphasis: 'You have right to elect no federal income tax ',
        description: ['withholding by chosing "No, Do not Withhold. '],
      },
      {
        emphasis: 'State Tax ',
        description: [
          'will be withheld per applicable state ' +
            'law if your address of record is in a state that defaults to' +
            ' witholdings.',
        ],
      },
    ],
  },
  [TAX_WITHHOLDING_STEP]: {
    title: 'A Quick Note About Taxes',
    altTitle: 'Federal Income Tax Withholding Disclosure',
    subTopics: [
      {
        emphasis:
          'Your withholding rate is determined by the type of payment you will receive.',
        description: [
          <span>
            {' '}
            For nonperiodic payments, the default withholding is 10% and you can
            select to have a different rate by entering a rate between 0% and
            99% on the following step. You can't choose less than 10% for
            payments to be delivered outside the United States and its
            territories. Please{' '}
            <a
              href="https://www.troweprice.com/personal-investing/help/contact/index.html"
              rel="noopener noreferrer"
              target="_blank"
            >
              contact us
            </a>{' '}
            if you want an election of 100%.
          </span>,
        ],
      },
      {
        emphasis: 'Caution: ',
        description: [
          <span>
            If you have too little tax withheld, you will generally owe tax when
            you file your tax return and may owe a penalty unless you make
            timely payments of estimated tax. If too much tax is withheld, you
            will generally be due a refund when you file your tax return. Your
            withholding choice (or an election not to have withholding on a
            nonperiodic payment) will generally apply to any future payment from
            the same plan or IRA. Submit a new{' '}
            <a
              href="https://www.irs.gov/pub/irs-pdf/fw4r.pdf"
              rel="noopener noreferrer"
              target="_blank"
            >
              Form W-4R
            </a>{' '}
            if you want to change your election.
          </span>,
        ],
      },
    ],
  },
};

export const VERIFICATION_STATUS = {
  INITIATED: 'INITIATED',
  READY_FOR_VALIDATION: 'READY_FOR_VALIDATION',
  VERIFIED: 'VERIFIED',
  REINITIATED: 'REINITIATED',
  INITIATION_FAIL: 'INITIATION_FAIL',
  FAILED: 'FAILED',
  LAPSED: 'LAPSED',
  DELETED: 'DELETED',
  DEPOSIT_FAIL: 'DEPOSIT_FAIL',
};

export const PURCHASE_BLOCKED = 'purchaseBlocked';
export const RETURN_MAIL = 'returnMail';
export const PENDING = 'pending';
export const TEMPORARILY_STOP_TRANSFER = 'stopTransfer';
export const UNAVAILABLE_ONLINE = 'onlineBlocked';
export const BANK_NOT_LINKED = 'bankbankNotLinked';
export const ZERO_BALANCE = 'zeroBalance';
export const EXISTING_AUTO_EXCHANGE = 'existingAutoExchange';
export const EXISTING_AUTO_SELL = 'existingAutoSell';
export const EXISTING_AUTO_EXCHANGE_SELL = 'existingAutoExchangeSell';
export const PENDING_BANK_ASSOCIATION = 'pendingBankAssociation';
export const EXISTING_DISPROPORTIONATE_RMD = 'EXISTING_DISPROPORTIONATE_RMD';
export const IN_ELIGIBLE = 'InEligible';
export const selectableDays = [
  { label: '1', value: 1 },
  { label: '2', value: 2 },
  { label: '3', value: 3 },
  { label: '4', value: 4 },
  { label: '5', value: 5 },
  { label: '6', value: 6 },
  { label: '7', value: 7 },
  { label: '8', value: 8 },
  { label: '9', value: 9 },
  { label: '10', value: 10 },
  { label: '11', value: 11 },
  { label: '12', value: 12 },
  { label: '13', value: 13 },
  { label: '14', value: 14 },
  { label: '15', value: 15 },
  { label: '16', value: 16 },
  { label: '17', value: 17 },
  { label: '18', value: 18 },
  { label: '19', value: 19 },
  { label: '20', value: 20 },
  { label: '21', value: 21 },
  { label: '22', value: 22 },
  { label: '23', value: 23 },
  { label: '24', value: 24 },
  { label: '25', value: 25 },
  { label: '26', value: 26 },
  { label: '27', value: 27 },
  { label: '28', value: 28 },
  { label: '29', value: 29 },
  { label: '30', value: 30 },
  { label: '31', value: 31 },
];
export const selectableMonths = [
  { label: 'JAN', value: 0, txtVal: '0' },
  { label: 'FEB', value: 1, txtVal: '1' },
  { label: 'MAR', value: 2, txtVal: '2' },
  { label: 'APR', value: 3, txtVal: '3' },
  { label: 'MAY', value: 4, txtVal: '4' },
  { label: 'JUN', value: 5, txtVal: '5' },
  { label: 'JUL', value: 6, txtVal: '6' },
  { label: 'AUG', value: 7, txtVal: '7' },
  { label: 'SEP', value: 8, txtVal: '8' },
  { label: 'OCT', value: 9, txtVal: '9' },
  { label: 'NOV', value: 10, txtVal: '10' },
  { label: 'DEC', value: 11, txtVal: '11' },
];

export const REVIEW_STEPS = [
  { label: 'Delivery', value: appendBasePath('/destination') },
  { label: 'Personal Information', value: '' },
  { label: 'Distribution Method', value: appendBasePath('/distribution') },
  { label: 'Frequency', value: appendBasePath('/frequency') },
  {
    label: 'Income Tax Withholding',
    value: appendBasePath('/tax-withholding'),
  },
];

export const MONTH_NAMES = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];

export const serviceLinks = {
  'Personal Services':
    config.url +
    '/vc2/public/Retail/hSecureSelectClientServices/Personal-Services',
  'Enhanced Personal Services':
    config.url +
    '/vc2/public/Retail/hSecureSelectClientServices/Enhanced-Personal-Services',
};

export const highValuedClientList = [
  'Personal Services',
  'Enhanced Personal Services',
];

export const eligibleBankStatusesMap = {
  [VERIFICATION_STATUS.INITIATED]: true,
  [VERIFICATION_STATUS.READY_FOR_VALIDATION]: true,
  [VERIFICATION_STATUS.VERIFIED]: true,
  [VERIFICATION_STATUS.REINITIATED]: true,
  [VERIFICATION_STATUS.LAPSED]: true,
};

export const PRODUCT_TYPE_ENUM_MAP = {
  MUTUAL_FUND: 10,
  BROKERAGE: 20,
  VARIABLE_ANNUITY: 30,
  WORKPLACE_RETIREMENT: 50,
  RETIREMENT_PLAN: 60,
  DEFINED_BENEFIT: 61,
  RPS_TRADELINK_SUMMARY: 62,

  RPS_TRADELINK_INDIVIDUAL: 63,
  NATIONAL_529: 80,
  MARYLAND_529: 40,
  ALASKA_529: 70,
  EXTERNAL_PLAN: 90,
  JOHN_HANCOCK_529: 100,
  MANAGED_ACCOUNT: 110,
  RETIREMENT_ADVISORY: 120,

  // mapping both the Java keys and the Java names since both are used in different places
  MutualFund: 10,
  Brokerage: 20,
  VariableAnnuity: 30,
  WorkplaceRetirement: 50,
  RetirementPlan: 60,
  DefinedBenefit: 61,
  RPSTradeLinkSummary: 62,

  RPSTradeLinkIndividual: 63,
  National529: 80,
  Maryland529: 40,
  Alaska529: 70,
  'External plans': 90,
  'John Hancock 529': 100,
  ManagedAccount: 110,
  RetirementAdvisory: 120,
};

export const OK_AND_DC_TAX_EVENT = 'November 18, 2022, 16:00:00';

export const PREVIOUS_YEAR_RMD =
  'You did not own any RMD eligible accounts at T. Rowe Price as of December 31st of the previous year.';

export const PRODUCT_TYPE_LABEL_MAP = {
  MUTUAL_FUND: 'Mutual Fund',
  BROKERAGE: 'Brokerage',
  VARIABLE_ANNUITY: 'Variable Annuity',
  MARYLAND_529: 'Maryland Senator Edward J. Kasemeyer College Investment Plan',
  WORKPLACE_RETIREMENT: 'Workplace Retirement',
  RETIREMENT_PLAN: 'Small Business Retirement',
  DEFINED_BENEFIT: 'Defined Benefit',
  RPS_TRADELINK_SUMMARY: 'Workplace Retirement',

  RPS_TRADELINK_INDIVIDUAL: 'Workplace Retirement',
  ALASKA_529: 'Alaska 529',
  NATIONAL_529: `T. Rowe Price College Savings Plan`,
  EXTERNAL_PLAN: 'External Plan',
  JOHN_HANCOCK_529: 'John Hancock 529 College Savings Plan',
  MANAGED_ACCOUNT: 'ActivePlus Portfolio',

  // mapping both the Java keys and the Java names since both are used in different places
  MutualFund: 'Mutual Fund',
  Brokerage: 'Brokerage',
  VariableAnnuity: 'Variable Annuity',
  Maryland529: 'Maryland Senator Edward J. Kasemeyer College Investment Plan',
  WorkplaceRetirement: 'Workplace Retirement',
  RetirementPlan: 'Small Business Retirement',
  DefinedBenefit: 'Defined Benefit',
  RPSTradeLinkSummary: 'Workplace Retirement',

  RPSTradeLinkIndividual: 'Workplace Retirement',
  Alaska529: 'Alaska 529',
  National529: `T. Rowe Price College Savings Plan`,
  'External plans': 'External Plan',
  'John Hancock 529': 'John Hancock 529 College Savings Plan',
  ManagedAccount: 'ActivePlus Portfolio',
};

// export enum AGREEMENT_TYPES {
//   COLLEGE_SAVINGS = 'COLLEGE_SAVINGS',
//     CORPORATE = 'CORPORATE',
//     DEFINED_BENEFIT = 'DEFINED_BENEFIT',
//     EDUCATION_SAVINGS_ACCOUNT = 'EDUCATION_SAVINGS_ACCOUNT',
//     ESTATE = 'ESTATE',
//     FIS = 'FIS',
//     GUARANTEED_INVESTMENT_CONTRACT = 'GUARANTEED_INVESTMENT_CONTRACT',
//     INDIVIDUAL_401K = 'INDIVIDUAL_401K',
//     INDIVIDUAL = 'INDIVIDUAL',
//     JOHN_HANCOCK_GUARDIAN = 'JOHN_HANCOCK_GUARDIAN',
//     JOHN_HANCOCK_TRUST = 'JOHN_HANCOCK_TRUST',
//     JOHN_HANCOCK_UGMA_UTMA = 'JOHN_HANCOCK_UGMA_UTMA',
//     JOINT_TENANT = 'JOINT_TENANT',
//     KEOGH = 'KEOGH',
//     MONEY_PURCHASE_PENSION_PLAN = 'MONEY_PURCHASE_PENSION_PLAN',
//     NON_FIDUCIARY_RETIREMENT_PLAN = 'NON_FIDUCIARY_RETIREMENT_PLAN',
//     NON_PROFIT_ORGANIZATION = 'NON_PROFIT_ORGANIZATION',
//     NON_QUALIFIED_RPS = 'NON_QUALIFIED_RPS',
//     ORGANIZATION = 'ORGANIZATION',
//     OTHER = 'OTHER',
//     POWER_OF_ATTORNEY = 'POWER_OF_ATTORNEY',
//     PROFIT_SHARING_PLAN = 'PROFIT_SHARING_PLAN',
//     RETIREMENT_PLAN_401A = 'RETIREMENT_PLAN_401A',
//     RETIREMENT_PLAN_401K_FUND_REACH = 'RETIREMENT_PLAN_401K_FUND_REACH',
//     RETIREMENT_PLAN_401K = 'RETIREMENT_PLAN_401K',
//     RETIREMENT_PLAN_403 = 'RETIREMENT_PLAN_403',
//     RETIREMENT_PLAN_457 = 'RETIREMENT_PLAN_457',
//     RETIREMENT_PLAN_BENE_DUE_TO_DEATH = 'RETIREMENT_PLAN_BENE_DUE_TO_DEATH',
//     RETIREMENT_PLAN_DECEASED = 'RETIREMENT_PLAN_DECEASED',
//     RETIREMENT_PLAN = 'RETIREMENT_PLAN',
//     ROLLOVER = 'ROLLOVER',
//     ROLLOVER_IRA = 'ROLLOVER_IRA',
//     ROTH_IRA_DECEASED_BENE = 'ROTH_IRA_DECEASED_BENE',
//     ROTH_IRA_DECEASED = 'ROTH_IRA_DECEASED',
//     ROTH_IRA = 'ROTH_IRA',
//     ROTH_ROLLOVER_IRA = 'ROTH_ROLLOVER_IRA',
//     SAR_SEP = 'SAR_SEP',
//     SEP_IRA = 'SEP_IRA',
//     SIM_401K = 'SIM_401K',
//     SIMPLE_IRA = 'SIMPLE_IRA',
//     TRADITIONAL_IRA_DECEASED_BENE = 'TRADITIONAL_IRA_DECEASED_BENE',
//     TRADITIONAL_IRA_DECEASED = 'TRADITIONAL_IRA_DECEASED',
//     TRADITIONAL_IRA = 'TRADITIONAL_IRA',
//     TRANSFER_ON_DEATH = 'TRANSFER_ON_DEATH',
//     TRUST = 'TRUST',
//     UGMA_UTMA = 'UGMA_UTMA',
//     ROTH_ROLLOVER = 'ROTH_ROLLOVER',
//     NON_FIDUCIARY_PLAN = 'NON_FIDUCIARY_PLAN',
// }

export const FundNoteBuy = {
  ADDRESS_UNDELIVERABLE: 'BUY_FUND_NOTE_ADDRESS_UNDELIVERABLE',
  APP_ZERO_DOLLAR_BALANCE: 'APP_ZERO_DOLLAR_BALANCE',
  AGE_RESTRICTED: 'BUY_FUND_NOTE_AGE_RESTRICTED',
  BANK_NOT_LINKED: 'BUY_FUND_NOTE_BANK_NOT_LINKED',
  BUCKET_ROLL: 'BUY_FUND_NOTE_BUCKET_ROLL',
  CANNOT_LINK_BANK: 'BUY_FUND_NOTE_CANNOT_LINK_BANK',
  CANNOT_REOPEN_ICLASS: 'BUY_FUND_NOTE_CANNOT_REOPEN_ICLASS',
  CANNOT_REOPEN_SUMMIT: 'BUY_FUND_NOTE_CANNOT_REOPEN_SUMMIT',
  CANNOT_PURCHASE_2020: 'BUY_FUND_NOTE_CANNOT_PURCHASE_2020',
  CLOSED_NEW: 'BUY_FUND_NOTE_CLOSED_NEW',
  COUNTRY_RESTRICTED: 'BUY_FUND_NOTE_COUNTRY_RESTRICTED',
  ESA_PLAN: 'BUY_FUND_NOTE_ESA_PLAN',
  INHERITED_FUND: 'BUY_FUND_NOTE_INHERITED_FUND',
  IRA_DECEASED: 'BUY_FUND_NOTE_IRA_DECEASED',
  MONEY_MARKET_EVENT_FEE_ACTIVE: 'BUY_FUND_NOTE_MONEY_MARKET_EVENT_FEE_ACTIVE',
  MONEY_MARKET_EVENT_FEE_REMOVED:
    'BUY_FUND_NOTE_MONEY_MARKET_EVENT_FEE_REMOVED',
  MONEY_MARKET_EVENT_GATE_ACTIVE:
    'BUY_FUND_NOTE_MONEY_MARKET_EVENT_GATE_ACTIVE',
  MONEY_MARKET_EVENT_GATE_REMOVED:
    'BUY_FUND_NOTE_MONEY_MARKET_EVENT_GATE_REMOVED',
  ONLINE_PURCHASE_RESTRICTED: 'BUY_FUND_NOTE_ONLINE_PURCHASE_RESTRICTED',
  PENDING: 'BUY_FUND_NOTE_PENDING',
  PENDING_STATUS: 'PENDING_STATUS_AGREEMENTS',
  RECENTLY_REDEEMED: 'BUY_FUND_NOTE_RECENTLY_REDEEMED',
  STOP_PURCHASE: 'BUY_FUND_NOTE_STOP_PURCHASE',
  EXISTING_ICLASS: 'EXISTING_ICLASS',
};
